import { Trans } from '@lingui/react/macro';
import { Breakpoint, FormControlLabel } from '@mui/material';
import React from 'react';

import { usePersistedState } from '../../../hooks/usePersistedState';
import { PrimaryButton } from '../../buttons';
import { Checkbox } from '../../Checkbox';
import { Dialog, DialogActions, DialogContent } from '../../Dialog';
import { Flexbox } from '../../Flexbox';
import { Text } from '../../Text';

export function StepHelpDialog({
    title,
    body,
    width = 'md',
    storage,
}: {
    title: string;
    body: JSX.Element;
    width?: Breakpoint;
    storage?: { storage: Storage; storageKey: string };
}): JSX.Element {
    const [hideForeverLabel, setHideForever] = usePersistedState<'true' | ''>(
        storage ? storage.storageKey + '-hide-dialog-forever-' + title : 'hide-dialog-forever' + title,
        '',
        storage?.storage,
    );
    const hideForever = hideForeverLabel === 'true';
    const [isVisible, setVisible] = React.useState(true);
    const [checked, setChecked] = React.useState(false);

    const showDialog = !hideForever && isVisible;

    return (
        <>
            <Dialog maxWidth={width ?? false} onClose={() => setVisible(false)} title={title} open={showDialog}>
                <DialogContent>{body}</DialogContent>
                <DialogActions
                    sx={{
                        padding: '16px 24px',
                    }}
                >
                    <Flexbox
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <FormControlLabel
                            style={{ gap: '8px', userSelect: 'none' }}
                            control={<Checkbox checked={checked} onChange={() => setChecked(!checked)} size="small" />}
                            label={
                                <Text>
                                    <Trans>Never show this dialog again</Trans>
                                </Text>
                            }
                        />
                    </Flexbox>
                    <span style={{ flexGrow: 1 }} />
                    <PrimaryButton
                        onClick={() => {
                            setVisible(false);
                            if (checked) {
                                setHideForever('true');
                            }
                        }}
                        size="small"
                        autoFocus
                        disableFocusRipple
                    >
                        <Trans>OK</Trans>
                    </PrimaryButton>
                </DialogActions>
            </Dialog>
        </>
    );
}
